export type VariantPriceRange = {
  count: number
  min: number
  max: number
  hasRange: boolean
}

export function variantPriceRange(items: unknown): VariantPriceRange {
  const list = Array.isArray(items) ? items : []

  const prices = list
    .map((item) => Number(item?.price))
    .filter((price) => Number.isFinite(price) && price > 0)

  const min = prices.length ? Math.min(...prices) : 0
  const max = prices.length ? Math.max(...prices) : 0

  return { count: list.length, min, max, hasRange: list.length > 1 && max > min }
}
